import React, { Component } from "react";
import { connect } from "react-redux";
import {
	createNewCheckout,
	createNewViajanetRedirect,
	toggleModal,
	flightDirectionRedirect
} from "../actions";

import Popover from "./Popover";
import { Tooltip } from "react-tippy";

import {
	getFeesSumPerPassengerType,
	sumAttributes,
	sumTaxesPerPurchase,
	feesTranslations,
	getSalesResumePerPassengerType,
	getSalesResumePerPassengerTypeCampaing,
	sumFlightPricesByPassengerType,
	passengerTypeTranslation,
	outputBase64FromSelectedFlights,
	formatCurrency,
	searchAlternativeFlight,
	getLuggageFrom,
	stretchesHasSameCompanies,
	bestMaxMilhasPrice,
	dateDifference,
	sendSelectedFlightDito
} from "../shared/utils";
import { getFlightCheckoutDetails } from "../shared/requests-api";
import { $, getRedirectAddressAfterTimeout } from "../shared/utils";
import { airportChange } from "../shared/mocks/modal-airport-change";
import tingle from "tingle.js";
import PubSub from "pubsub-js";
import "../shared/pubsub-triggers";
import OutputLuggageInformation from "./OutputLuggageInformation";
import moment from "moment";
import { OPEN_MODAL, UPDATE_SELECTED_FLIGHT, IS_PROD , PROMOTION_TEXT_DATE_PREFIX, PROMOTION_TEXT_DATE, PROMOTION_TEXT_TITLE } from "../shared/constants";
import { store } from "../react-app";
import getURLParams from "../shared/getURLParams";


let modalAirportChange = {};
let controlPush = false;
let modalSearchAgain = {};

let isTypePassageFiltered = sessionStorage.getItem("p") && ((IS_PROD && location.host === "www.maxmilhas.com.br") || !IS_PROD);

export class FlightBillingResume extends Component {
	constructor() {
		super();
		this.state = {
			serviceFeeValue: "calculando...",
			creatingCheckout: false,
			updatedFlightsData: null,
			isCalculating: true,
			showTooltip: false,
			lock: true
		};

		this.toogleTooltip = this.toogleTooltip.bind(this);

		if (sessionStorage.getItem("p") && sessionStorage.getItem("p").indexOf("_") > -1) {
			isTypePassageFiltered = false;
		}
	}

	componentDidMount() {
		const { inbound: inboundFlight, outbound: outboundFlight } = this.props.selectedFlights;
		const isExclusiveCompanies =
			outboundFlight[0].otaAvailableIn === "airline" ||
			(inboundFlight[0] && inboundFlight[0].otaAvailableIn === "airline");

		if (isExclusiveCompanies || this.props.hasFlightsFromDifferentCompanies) {
			this.setState({
				isCalculating: false,
				updatedFlightsData: { outbound: outboundFlight[0], inbound: inboundFlight[0] }
			});
		}
	}

	componentDidUpdate() {
		const { inbound: inboundFlight, outbound: outboundFlight } = this.props.selectedFlights;
		const isExclusiveCompanies =
			outboundFlight[0].otaAvailableIn === "airline" ||
			(inboundFlight[0] && inboundFlight[0].otaAvailableIn === "airline");

		if (!isExclusiveCompanies) {
			let calculateService = true;

			if (this.props.isInternational && this.hasFlightsFromDifferentCompanies()) {
				calculateService = false;
			}

			if (calculateService) {
				this.calculateServiceFee();
			}
		}
	}

	sumAirlinePrice() {
		if (!this.hasUpdatedFlights()) return 0;

		let totalWithTaxes = 0;

		if (
			this.state.updatedFlightsData.outbound &&
			this.state.updatedFlightsData.outbound.pricing.airline !== null
		)
			totalWithTaxes += this.state.updatedFlightsData.outbound.pricing.airline.saleTotal;

		if (
			this.state.updatedFlightsData.inbound &&
			this.state.updatedFlightsData.inbound.pricing.airline !== null
		)
			totalWithTaxes += this.state.updatedFlightsData.inbound.pricing.airline.saleTotal;

		return totalWithTaxes;
	}

	sumMaxPrice() {
		if (!this.hasUpdatedFlights()) return 0;

		let totalWithTaxes = 0;

		if (
			this.state.updatedFlightsData.outbound &&
			this.state.updatedFlightsData.outbound.pricing.mmBestPriceAt !== null
		) {
			const bestOutboundPrice = bestMaxMilhasPrice(this.state.updatedFlightsData.outbound.pricing);
			totalWithTaxes += bestOutboundPrice.saleTotal;
		}

		if (
			this.state.updatedFlightsData.inbound &&
			this.state.updatedFlightsData.inbound.pricing.mmBestPriceAt !== null
		) {
			const bestInboundPrice = bestMaxMilhasPrice(this.state.updatedFlightsData.inbound.pricing);
			totalWithTaxes += bestInboundPrice.saleTotal;
		}

		return totalWithTaxes;
	}

	defineRenderScenario() {
		const { inbound: inboundFlight, outbound: outboundFlight } = this.props.selectedFlights;
		const tripType = this.props.searchParams.tripType;

		if (tripType === "RT" && (inboundFlight.length <= 0 || outboundFlight.length <= 0)) {
			return;
		}

		const airlineIsNull =
			outboundFlight[0].pricing.airline == null ||
			(inboundFlight[0] && inboundFlight[0].pricing.airline == null);
		const isExclusiveCompany =
			outboundFlight[0].otaAvailableIn === "airline" ||
			(inboundFlight[0] && inboundFlight[0].otaAvailableIn === "airline");

		const maxPrice = this.sumMaxPrice();
		const airlinePrice = this.sumAirlinePrice();

		if (
			typeof maxPrice !== "undefined" &&
			maxPrice !== null &&
			typeof airlinePrice !== "undefined" &&
			airlinePrice !== null &&
			!controlPush
		) {
			controlPush = true;

			let price = airlinePrice;

			if (airlinePrice === 0 || maxPrice < airlinePrice) {
				price = maxPrice;
			}

			const search = this.props.searchParams;

			let cabin = "first";
			if (search.cabin === "EC") {
				cabin = "economy";
			}

			if (search.cabin === "EX") {
				cabin = "premium";
			}

			if (outboundFlight[0]) {
				let fbObj = {
					departing_departure_date: outboundFlight[0].departureDate,
					returning_departure_date: outboundFlight[0].arrivalDate,
					origin_airport: search.from,
					destination_airport: search.to,
					num_adults: search.adults,
					num_children: search.children,
					num_infants: search.infants,
					travel_class: cabin, // must be 'economy', 'premium', 'business' or 'first'
					price: price // Preço do voo
				};

				if (this.props.searchParams.tripType === "RT" && inboundFlight[0]) {
					fbObj["departing_arrival_date"] = inboundFlight[0].departureDate;
					fbObj["returning_arrival_date"] = inboundFlight[0].arrivalDate;
				}

				PubSub.publish("dataLayer", {
					event: "fbSearch",
					fbSearch: fbObj
				});

				delete fbObj.price;
				PubSub.publish("dataLayer", {
					event: "fbViewContent",
					fbViewContent: fbObj
				});
			}

			PubSub.publish("dataLayer", {
				event: "gaEvent",
				gaEventCategory: "Processo de compra",
				gaEventAction: "Escolheu Passagem",
				gaEventLabel: "",
				gaEventValue: ""
			});
		}

		// Voo internacionl com cias diferentes
		if (this.props.isInternational == true && inboundFlight[0]) {
			if (outboundFlight[0].airline !== inboundFlight[0].airline) {
				return this.internationalWithDiffCompaniesScenario();
			}
		}

		if (!isExclusiveCompany) {
			// Melhor na MaxMilhas
			if (airlinePrice > maxPrice) {
				return this.buyItemsScenarios(1);
			}

			// Igual
			if (airlineIsNull || airlinePrice == maxPrice) {
				return this.buyItemsScenarios(0);
			}

			// Melhor na CIA
			if (airlinePrice < maxPrice) {
				return this.buyItemsScenarios(-1);
			}
		}
	}

	hasFlightsFromDifferentCompanies() {
		if (!this.props.selectedFlights) return false;

		const { inbound: inboundFlight, outbound: outboundFlight } = this.props.selectedFlights;

		if (inboundFlight.length > 0 && outboundFlight.length > 0)
			return inboundFlight[0].airline !== outboundFlight[0].airline;

		return false;
	}

	/**
	 * Render Helpers
	 */

	hasUpdatedFlights() {
		return this.state.updatedFlightsData !== null;
	}

	outputAirlinePricing() {
		if (!this.hasUpdatedFlights()) return null;

		const outboundUpdatedFlight = this.state.updatedFlightsData.outbound;
		const inboundUpdatedFlight = this.state.updatedFlightsData.inbound;

		if (outboundUpdatedFlight.otaAvailableIn !== "both") {
			return;
		}

		if (inboundUpdatedFlight && inboundUpdatedFlight.otaAvailableIn !== "both") {
			return;
		}

		if (
			outboundUpdatedFlight.pricing.airline === null ||
			(inboundUpdatedFlight && inboundUpdatedFlight.pricing.airline === null)
		) {
			return;
		}

		const totalAirline = this.sumAirlinePrice();
		const totalMax = this.sumMaxPrice();

		return (
			<div className="airline-pricing value-line text-muted">
				{this.outputAirlineNaming(
					this.outputFlight("outbound"),
					this.outputFlight("inbound"),
					totalAirline == totalMax
				)}
				<span className={`${totalAirline == totalMax ? "" : "line-through"} price`}>
					{formatCurrency(totalAirline)}
				</span>
			</div>
		);
	}

	internationalWithDiffCompaniesScenario() {
		return (
			<div className="rollback-buy">
				<div className="alert alert-info" role="alert">
					<div className="alert--icon">
						<i className="icon-exclamation" />
					</div>
					<div className="alert--message">
						<p>
							Por enquanto não vendemos voos internacionais com companhias diferentes. Selecione um
							voo da mesma companhia.
						</p>
					</div>
				</div>
			</div>
		);
	}

	outputAirlineNaming(outboundFlight, inboundFlight, samePrice) {
		let prefix = samePrice ? "Mesmo p" : "P";

		if (stretchesHasSameCompanies([outboundFlight, inboundFlight]) || inboundFlight === null) {
			return (
				<p className="title">
					{prefix}
					reço na {outboundFlight.airline.toUpperCase()} com taxas
				</p>
			);
		} else {
			return (
				<p className="title">
					{prefix}
					reço total na {outboundFlight.airline.toUpperCase()} e{" "}
					{inboundFlight.airline.toUpperCase()} com taxas
				</p>
			);
		}
	}

	outputFlight(stretch) {
		if (this.props.selectedFlights[stretch].length > 0)
			return this.props.selectedFlights[stretch][0];

		return null;
	}


	renderFees() {
		if (!this.hasUpdatedFlights()) return;

		const { inbound: inboundFlight, outbound: outboundFlight } = this.state.updatedFlightsData;

		let outboundTaxes,
			inboundTaxes = {};

		if (outboundFlight) {
			const maxOutboundPricing = bestMaxMilhasPrice(outboundFlight.pricing);
			outboundTaxes = getFeesSumPerPassengerType(maxOutboundPricing);
		}

		if (inboundFlight) {
			const maxInboundPricing = bestMaxMilhasPrice(inboundFlight.pricing);
			inboundTaxes = getFeesSumPerPassengerType(maxInboundPricing);
		}

		const totalFees = sumAttributes([outboundTaxes, inboundTaxes]);

		let total = 0;
		let fees =  [];

		Object.keys(totalFees).map((fee, key) => {
			total += totalFees[fee];			

			fees.push({ key: feesTranslations[fee], value: totalFees[fee] });
		});

		return (
			<div className="values-list__item">
				<span className="values-list__text">
					Taxas e encargos{" "}
					<Tooltip
						tabIndex={"0"}
						html={<Popover listas={[fees]} />}
						position="top"
						arrow={true}
					>
						<i className="tooltip">?</i>
					</Tooltip>
				</span>
				<span className="values-list__number">{formatCurrency(total)}</span>
			</div>
		);
	}

	selectPriceshowMode() {
		if (!this.hasUpdatedFlights()) return null;

		return this.state.updatedFlightsData.outbound.pricing.promotion
			? this.showFlightPricesPerPassengerTypeCampaing()
			: this.showFlightPricesPerPassengerType();
	}

	showFlightPricesPerPassengerType() {
		if (!this.hasUpdatedFlights()) return null;

		let outboundPricingResume,
			inboundPricingResume = {};
		let passengersGroup = {};

		if (this.state.updatedFlightsData.outbound) {
			const maxOutboundPricing = bestMaxMilhasPrice(this.state.updatedFlightsData.outbound.pricing);
			outboundPricingResume = getSalesResumePerPassengerType(maxOutboundPricing);
		}

		if (this.state.updatedFlightsData.inbound) {
			const maxInboundPricing = bestMaxMilhasPrice(this.state.updatedFlightsData.inbound.pricing);
			inboundPricingResume = getSalesResumePerPassengerType(maxInboundPricing);
		}

		passengersGroup = sumFlightPricesByPassengerType([inboundPricingResume, outboundPricingResume]);

		return (
			<div className="passengers-pricing-resume">
				{Object.keys(passengersGroup).map((passengerType, i) => (
					<p className="value-line" key={"passenger-pricing-" + i}>
						{passengerTypeTranslation[passengerType]}
						<span className="passenger-pricing">
							{formatCurrency(passengersGroup[passengerType].fare || 0)}
							&nbsp;(
							{passengersGroup[passengerType].quantity}
							<small>x</small>)
						</span>
					</p>
				))}
				<hr />
			</div>
		);
	}

	showFlightPricesPerPassengerTypeCampaing() {
		if (!this.hasUpdatedFlights()) return null;

		let outboundPricingResume,
			inboundPricingResume = {};
		let passengersGroup = {};

		if (this.state.updatedFlightsData.outbound) {
			const maxOutboundPricing = bestMaxMilhasPrice(this.state.updatedFlightsData.outbound.pricing);
			outboundPricingResume = getSalesResumePerPassengerTypeCampaing(
				this.state.updatedFlightsData.outbound.pricing.promotion,
				maxOutboundPricing
			);
		}

		if (this.state.updatedFlightsData.inbound) {
			const maxInboundPricing = bestMaxMilhasPrice(this.state.updatedFlightsData.inbound.pricing);
			inboundPricingResume = getSalesResumePerPassengerTypeCampaing(
				this.state.updatedFlightsData.inbound.pricing.promotion,
				maxInboundPricing
			);
		}

		passengersGroup = sumFlightPricesByPassengerType([inboundPricingResume, outboundPricingResume]);

		return (
			<div className="passengers-pricing-resume">
				{Object.keys(passengersGroup).map((passengerType, i) => (
					<p className="value-line" key={"passenger-pricing-" + i}>
						{passengerTypeTranslation[passengerType]}
						<span className="passenger-pricing">
							{formatCurrency(passengersGroup[passengerType].fare || 0)}
							&nbsp;({passengersGroup[passengerType].quantity}
							<small>x</small>)
						</span>
					</p>
				))}
				<hr />
			</div>
		);
	}

	showInfoAlert() {
		if (!this.hasUpdatedFlights()) return null;

		const { selectedFlights } = this.props;

		let hasPromotion = selectedFlights.outbound[0].pricing.hasOwnProperty("promotion");

		if (this.props.searchParams.tripType === "RT") {
			if (!hasPromotion) {
				hasPromotion = selectedFlights.inbound[0].pricing.hasOwnProperty("promotion");
			}
		}

		if (hasPromotion) {
			return (
				<div className="alert alert--default no-margin-bottom" role="alert">
					<div className="alert--message">
						<p>
							{/* { PROMOTION_TEXT_DATE_PREFIX } <strong className="text-info text-uppercase">{ PROMOTION_TEXT_DATE }</strong>{" "}
							não realizaremos a aplicação de cupom. Aproveite nossos descontos exclusivos em toda plataforma;) */}
							Em dias de campanha, não fazemos aplicações de cupom. Aproveite nossos descontos exclusivos em toda a plataforma!;)
						</p>
					</div>
				</div>
			);
		}
	}

	calculateServiceFee() {
		const { createCheckoutData } = this.props;
		const { serviceFeeValue, lock } = this.state;

		const isNotCalculating = !createCheckoutData.outboundId || serviceFeeValue !== "calculando...";
		if (isNotCalculating) {
			if (typeof serviceFeeValue == "string") {
				return <span className="fee-value">{serviceFeeValue}</span>;
			}

			if (typeof serviceFeeValue == "number") {
				return <span className="fee-value">{formatCurrency(serviceFeeValue)}</span>;
			}
		}

		if (!lock) {
			return;
		}
		const self = this;
		this.setState({ lock: false });

		let flightIds = [];
		if (createCheckoutData.outboundId) {
			flightIds.push(createCheckoutData.outboundId);
		}
		if (createCheckoutData.inboundId) {
			flightIds.push(createCheckoutData.inboundId);
		}

		function publishDito(flightsInfo, outboundFlight, inboundFlight) {
			try {
				const flightParams = flightsInfo.parameters;

				const todayDay = moment(new Date()).format("YYYY-MM-DD");
				const daysUntilTravel = dateDifference(todayDay, flightParams.outboundDate, "days");

				const flightSelectedOutbound = sendSelectedFlightDito(outboundFlight[0], "ida");

				let data = {
					dias_ate_viagem: daysUntilTravel,
					tipo_destino: flightsInfo.isInternational ? "Internacional" : "Nacional",
					pais_origem: flightParams.fromCountry,
					pais_destino: flightParams.toCountry,
					...flightSelectedOutbound
				};

				if (inboundFlight.length > 0) {
					const flightSelectedInbound = sendSelectedFlightDito(inboundFlight[0], "volta");

					data = {
						...data,
						...flightSelectedInbound
					};
				}

				PubSub.publish("dataLayer", {
					event: "ditoTrack",
					ditoTrack: {
						action: "acessou-detalhes-do-voo",
						data: data
					}
				});
			} catch (e) {
				console.error(e);
			}
		}

		function flightsFeeCalculated({ data }) {
			const flights = data.flights.filter(flight => {
				if (flight.direction === "outbound") {
					return createCheckoutData.outboundId && flight.id === createCheckoutData.outboundId;
				}
				if (flight.direction === "inbound") {
					return createCheckoutData.inboundId && flight.id === createCheckoutData.inboundId;
				}

				return false;
			});

			store.dispatch({
				type: UPDATE_SELECTED_FLIGHT,
				flights
			});

			const is = (flight, direction) => flight.direction === direction;
			const outboundFlight = flights.filter(flight => is(flight, "outbound"));
			const inboundFlight = flights.filter(flight => is(flight, "inbound"));

			let updatedFlightsData = {};
			if (outboundFlight && outboundFlight.length > 0) {
				updatedFlightsData.outbound = outboundFlight[0];
			}
			if (inboundFlight && inboundFlight.length > 0) {
				updatedFlightsData.inbound = inboundFlight[0];
			}
			self.setState({ updatedFlightsData });

			const taxesPerGroup = sumTaxesPerPurchase(flights);

			if (taxesPerGroup && taxesPerGroup.SERVICE_FEE) {
				self.setState({ serviceFeeValue: taxesPerGroup.SERVICE_FEE });
			} else {
				self.setState({ serviceFeeValue: 0 });
			}

			self.setState({ isCalculating: false });
			publishDito(data, outboundFlight, inboundFlight);
		}

		function flightFeeCalculationError(error) {
			self.setState({ serviceFeeValue: "A calcular", isCalculating: false });
			self.openErrorModal();
		}

		const isMetasearchOta = getURLParams(window.location.href).metasearch !== undefined;

		getFlightCheckoutDetails(flightIds, createCheckoutData.searchId, isMetasearchOta)
			.then(flightsFeeCalculated)
			.catch(flightFeeCalculationError);
	}

	openErrorModal(title = "Ocorreu um problema com a sua compra.", description = "Mas não desista, tente fazer uma nova busca.") {
		if (modalSearchAgain && modalSearchAgain.isOpen) {
			return;
		}
		modalSearchAgain = new tingle.modal({
			footer: false,
			closeMethods: [],
			onOpen: function () {
				$("#btn-try-purchase-again").onclick = e => {
					e.preventDefault();
					modalSearchAgain.isOpen = false;
					window.location.href = getRedirectAddressAfterTimeout();
					modalSearchAgain.destroy();
				};
			}
		});

		modalSearchAgain.isOpen = true;

		modalSearchAgain.setContent(`
			<div class="modal-header-wrapper">  
				<h3 class="lead">${title}</h3>
				<p>${description}</p>
			</div>
			<div class="btn-group">           
				<a href="#" title="Alterar sua busca"  id="btn-try-purchase-again" class="btn btn-success btn-large">Buscar outro voo</a>
			</div>`);
		modalSearchAgain.open();
	}

	showSavings() {
		if (!this.props.selectedFlights) {
			return null;
		}

		const outboundSelectedFlight = this.props.selectedFlights.outbound[0];
		const inboundSelectedFlight = this.props.selectedFlights.inbound[0];

		if (
			outboundSelectedFlight.otaAvailableIn !== "both" ||
			(inboundSelectedFlight && inboundSelectedFlight.otaAvailableIn !== "both")
		) {
			return;
		}

		if (
			outboundSelectedFlight.pricing.airline === null ||
			(inboundSelectedFlight && inboundSelectedFlight.pricing.airline === null)
		) {
			return;
		}

		const maxPrice = this.sumMaxPrice();
		const airlinePrice = this.sumAirlinePrice();

		const savings = airlinePrice - maxPrice;

		if (savings > 0)
			return (
				<div className="economy-block">
					<section className="label-info">
						<p className="label-text">
							ECONOMIA DE <span className="economy-value">{formatCurrency(savings)}</span>
						</p>
					</section>
				</div>
			);
	}

	redirectToCompany() {
		let extractAttrs = ["arrivalDate", "departureDate", "from", "number", "to"];
		let encodedFlights = outputBase64FromSelectedFlights(this.props.selectedFlights, extractAttrs);
		let redirectURL = `http://www.maxmilhas.com.br/redirecionando/${
			this.outputFlight("outbound").airline
			}?search=${this.props.createCheckoutData.legacyId}&flights=${encodedFlights}`;
		window.open(redirectURL, "_blank");
	}

	selectedFlighstHasAirportChange() {
		const href = window.location.href;

		const isRoundTrip =
			(href.indexOf("inboundId") > -1 && href.indexOf("outboundId") > -1) ||
			this.props.searchParams.tripType === "RT";
		const outboundFlight = this.props.selectedFlights.outbound[0];
		const inboundFlight = isRoundTrip ? this.props.selectedFlights.inbound[0] : null;

		const outboundHasChange = outboundFlight.trips.filter((trip, index, trips) => {
			let nextTrip = trips[index + 1] ? trips[index + 1] : "lastTrip";
			return nextTrip !== "lastTrip" && trip.to !== nextTrip.from;
		});

		const inboundHasChange = isRoundTrip
			? inboundFlight.trips.filter((trip, index, trips) => {
				let nextTrip = trips[index + 1] ? trips[index + 1] : "lastTrip";
				return nextTrip !== "lastTrip" && trip.to !== nextTrip.from;
			})
			: [];

		return outboundHasChange.length > 0 || inboundHasChange.length > 0;
	}

	showAirportChangeModal() {
		if (!modalAirportChange.isOpen) {
			const self = this;

			modalAirportChange = new tingle.modal({
				footer: false,
				closeMethods: [],
				onOpen: function () {
					$("#btn_back_airport_change").onclick = e => {
						e.preventDefault();
						modalAirportChange.isOpen = false;
						modalAirportChange.destroy();
					};

					$("#btn_continue_to_checkout").onclick = e => {
						e.preventDefault();

						self.callCheckout();

						modalAirportChange.isOpen = false;
						modalAirportChange.destroy();
					};
				}
			});

			modalAirportChange.isOpen = true;
			modalAirportChange.setContent(airportChange);
			modalAirportChange.open();
		}
	}

	createCheckoutItem() {
		if (
			this.selectedFlighstHasAirportChange() &&
			this.props.selectedFlights.outbound[0].airline !== "latam"
		) {
			this.showAirportChangeModal();
			return;
		}

		try {
			PubSub.publish("dataLayer", {
				event: "gaEvent",
				gaEventCategory: "Processo de compra",
				gaEventAction: "Comprar na MaxMilhas",
				gaEventLabel: "",
				gaEventValue: ""
			});
		} catch (e) {
			console.log("PUBSUB error, botão comprar", e);
		}

		this.callCheckout();
	}

	callCheckout() {
		this.setState({ creatingCheckout: true });

		let target;

		if (this.props.selectedFlights.outbound[0].pricing.mmBestPriceAt === "ota") {
			target = this.props.selectedFlights.outbound[0].pricing.ota.checkout.target;
		}

		if (target && target === "viajanet") {
			PubSub.publish("dataLayer", {
				event: "gaEvent",
				gaEventCategory: "Pré-checkout",
				gaEventAction: "Direcionando para Viajanet",
				gaEventLabel: "",
				gaEventValue: ""
			});

			createNewViajanetRedirect(this.props.createCheckoutData)
				.then(res => {
					document.body.innerHTML += res;

					const formViajanet = $("#frmVN");

					if (formViajanet) {
						formViajanet.submit();
						formViajanet.parentNode.removeChild(formViajanet);
					}

					this.setState({ creatingCheckout: false });
				})
				.catch(er => {
					this.setState({ creatingCheckout: false });
				});
		} else {
			createNewCheckout(this.props.createCheckoutData)
				.then(e => console.log("checkout created"))
				.catch(er => {
					this.setState({ creatingCheckout: false });
					if (er.response && er.response.status === 409 && er.response.data.type === "FareNotFoundException") {
						this.openErrorModal("Voo indisponível na companhia aérea", "Não é possível seguir com a sua compra pois este voo se esgotou rapidamente na companhia. Faça uma nova pesquisa!");
					} else {
						this.openErrorModal();
					}
				});
		}
	}

	buyItemsScenarios(compare) {
		return (
			<div className="full-buy buy-at-maxmilhas">
				<div className="values-block">
					{compare > -1 && this.outputAirlinePricing()}
					{this.selectPriceshowMode()}
					{this.renderPromotionDiscount()}
					{this.renderFees()}
					{this.showLuggageInformation()}
					<p className="value-total-line">
						Total <span>{formatCurrency(this.sumMaxPrice())}</span>
					</p>
				</div>

				{isTypePassageFiltered ? (
					<div className="blocked-purchase">
						<p className="blocked-purchase__title">Escolheu {this.props.searchParams.tripType === "RT" ? "as passagens" : "a passagem"}?</p>
						<p>Agora responda o e-mail de <strong>remarcação</strong> com os <strong>dados {this.props.searchParams.tripType === "RT" ? "dos voos" : "do voo"}</strong> {this.props.searchParams.tripType === "RT" ? "escolhidos" : "escolhido"} para continuarmos o processo</p>
					</div>
				) : (
						<div>
							{compare > -1 && this.showSavings()}

							{this.showInfoAlert()}

							<button
								data-action="buy-at-maxmilhas"
								className="btn btn-success"
								onClick={this.createCheckoutItem.bind(this)}
								disabled={this.state.creatingCheckout}
							>
								<i
									className={
										this.state.creatingCheckout ? "loader loader-fetching" : "icon-arrow-right hidden"
									}
								/>
								Comprar agora
						</button>
						</div>
					)}
			</div>
		);
	}

	sumBestPrice() {
		let price = 0;

		const outbound = this.props.selectedFlights.outbound[0];

		if (outbound.otaAvailableIn === "airline" || outbound.pricing.bestPriceAt === "airline") {
			price = outbound.pricing.airline.saleTotal;
		} else {
			const maxPricing = bestMaxMilhasPrice(outbound.pricing);
			price = maxPricing.saleTotal;
		}

		if (this.props.selectedFlights.inbound.length == 0) return price;

		const inbound = this.props.selectedFlights.inbound[0];

		if (inbound.otaAvailableIn === "airline" || inbound.pricing.bestPriceAt === "airline") {
			price += inbound.pricing.airline.saleTotal;
		} else {
			const maxPricing = bestMaxMilhasPrice(inbound.pricing);
			price += maxPricing.saleTotal;
		}

		return price;
	}

	renderRedirections() {
		if (!this.state.isCalculating) {
			const { inbound: inboundFlight, outbound: outboundFlight } = this.props.selectedFlights;

			const maxPrice = this.sumMaxPrice();
			const bestCombinationPrice = this.sumBestPrice();

			const isExclusiveCompany =
				outboundFlight[0].otaAvailableIn === "airline" ||
				(inboundFlight[0] && inboundFlight[0].otaAvailableIn === "airline");

			if (this.render2RedirectSearchs(outboundFlight, inboundFlight)) {
				if (isExclusiveCompany || maxPrice > bestCombinationPrice) {
					return (
						<div className="redirect-wrapper">
							{this.renderRedirectSearch("outbound", true)}
							{this.renderRedirectSearch("inbound", true)}
						</div>
					);
				}
			} else {
				if (isExclusiveCompany || maxPrice > bestCombinationPrice) {
					return (
						<div className="redirect-wrapper">
							{this.renderRedirectSearch("outbound", false, formatCurrency(this.sumAirlinePrice()))}
						</div>
					);
				}
			}
		}
	}

	render2RedirectSearchs(outboundFlight, inboundFlight) {
		if (inboundFlight.length === 0) return false;

		const outboundAirlineIsCheapest =
			outboundFlight[0].otaAvailableIn === "airline" ||
			(outboundFlight[0].otaAvailableIn === "both" &&
				outboundFlight[0].pricing.bestPriceAt === "airline");
		const inboundAirlineIsCheapest =
			inboundFlight[0].otaAvailableIn === "airline" ||
			(inboundFlight[0].otaAvailableIn === "both" &&
				inboundFlight[0].pricing.bestPriceAt === "airline");

		const sameCheapestScenario = outboundAirlineIsCheapest === inboundAirlineIsCheapest;
		const sameAirline = outboundFlight[0].airline === inboundFlight[0].airline;

		if (sameCheapestScenario && sameAirline) return false;

		return true;
	}

	redirectToMaxmilhasOrCompany(tripType) {
		const flight = this.props.createCheckoutData.selectedFlights[tripType][0];

		const filterOnlySelectedFlight = (direction, props) => {
			return {
				outbound: direction === "outbound" ? [props.selectedFlights.outbound[0]] : null,
				inbound: direction === "inbound" ? [props.selectedFlights.inbound[0]] : null
			};
		};

		flight.pricing.bestPriceAt !== "airline"
			? searchAlternativeFlight(
				flight,
				filterOnlySelectedFlight(tripType, this.props),
				this.props.createCheckoutData.searchId,
				this.props.searchParams,
				window
			)
			: this.openRedirectModal(tripType);
	}

	openRedirectModal(tripType = "RoundTrip") {
		this.props.flightDirectionRedirect(tripType);
		this.props.openModal();
	}

	renderAfterFeeFetching() {
		let calculating = this.state.isCalculating;

		if (this.props.isInternational && this.hasFlightsFromDifferentCompanies()) {
			calculating = false;
		}

		if (calculating) {
			return (
				<div style={{ textAlign: "center" }}>
					<i className={"loader loader-fetching"} />
				</div>
			);
		}

		return this.defineRenderScenario();
	}

	toogleTooltip(stretch) {
		this.setState(prevState => ({
			showTooltip: { ...prevState.showTooltip, [stretch]: !prevState.showTooltip[stretch] }
		}));
	}

	showLuggageInformation() {
		let airlineOutbound = null,
			luggageOutbound = null,
			airlineInbound = null,
			luggageInbound = null;

		const outboundFlight = this.outputFlight("outbound");
		const inboundFlight = this.outputFlight("inbound");

		if (outboundFlight && inboundFlight) {
			airlineOutbound = outboundFlight.airline;
			luggageOutbound = getLuggageFrom(outboundFlight);
			airlineInbound = inboundFlight.airline;
			luggageInbound = getLuggageFrom(inboundFlight);
		} else if (outboundFlight) {
			airlineOutbound = outboundFlight.airline;
			luggageOutbound = getLuggageFrom(outboundFlight);
		}

		return (
			<OutputLuggageInformation
				airlineOutbound={airlineOutbound}
				luggageOutbound={luggageOutbound}
				airlineInbound={airlineInbound}
				luggageInbound={luggageInbound}
				pricing={{
					outbound: outboundFlight ? outboundFlight.pricing.mmBestPriceAt : null,
					inbound: inboundFlight ? inboundFlight.pricing.mmBestPriceAt : null
				}}
				showTooltip={this.state.showTooltip}
				toogleTooltip={this.toogleTooltip.bind(this)}
				value={null}
				outboundLuggageTotal={null}
				inboundLuggageTotal={null}
				notIncluded={null}
				isInternational={this.props.isInternational}
				luggageQuantity={null}
			/>
		);
	}

	renderRedirectSearch(strech, useStrech, cheaperPrice = null) {
		const flight = this.props.createCheckoutData.selectedFlights[strech][0];
		const trecho = strech === "outbound" ? "ida" : "volta";
		const airlineHasCheapestPrice =
			flight.otaAvailableIn === "airline" ||
			(flight.otaAvailableIn === "both" && flight.pricing.bestPriceAt === "airline");

		let title, textButton;

		if (airlineHasCheapestPrice) {
			title = (
				<div className="title">
					Preço
					{useStrech ? ` de ${trecho}` : ""} na
					<br />
					{flight.airline.toUpperCase()} com taxas
				</div>
			);

			textButton = `Pesquisar ${
				useStrech ? trecho : ""
				} no site da ${flight.airline.toUpperCase()}`;

			cheaperPrice =
				cheaperPrice == null ? formatCurrency(flight.pricing.airline.saleTotal) : cheaperPrice;
		} else {
			title = (
				<div className="title">
					Preço
					{useStrech ? ` de ${trecho}` : ""} na
					<br /> MaxMilhas com taxas
				</div>
			);

			textButton = `Pesquisar ${useStrech ? trecho : ""} na MaxMilhas`;

			const maxPrice = bestMaxMilhasPrice(flight.pricing);

			cheaperPrice = cheaperPrice == null ? formatCurrency(maxPrice.saleTotal) : cheaperPrice;
		}

		return (
			<div className="redirect-scenario">
				<div className="redirect-description">
					{title}
					<div className="price">
						{!airlineHasCheapestPrice &&
							flight.otaAvailableIn === "both" && (
								<small>
									na {flight.airline.toUpperCase()}{" "}
									<s>{formatCurrency(flight.pricing.airline.saleTotal)}</s>
								</small>
							)}
						{airlineHasCheapestPrice &&
							flight.otaAvailableIn === "both" &&
							useStrech && (
								<small>
									na MaxMilhas <s>{formatCurrency(bestMaxMilhasPrice(flight.pricing).saleTotal)}</s>
								</small>
							)}
						<div>{cheaperPrice}</div>
					</div>
				</div>
				<button
					className="btn btn-default"
					data-action="redirect-to-strech"
					onClick={() => this.redirectToMaxmilhasOrCompany(strech)}
				>
					{textButton}
				</button>
			</div>
		);
	}

	renderPromotionDiscount() {
		const { inbound, outbound } = this.props.selectedFlights;

		if (outbound[0].pricing.hasOwnProperty("promotion")) {
			let {
				pricing: {
					promotion: { originalPrice: originalPriceOutbound, promoPrice: promoPriceOutbound }
				}
			} = outbound[0];

			let discount;

			discount = originalPriceOutbound - promoPriceOutbound;

			if (inbound.length > 0) {
				let {
					pricing: {
						promotion: { originalPrice: originalPriceInbound, promoPrice: promoPriceInbound }
					}
				} = inbound[0];

				discount += originalPriceInbound - promoPriceInbound;
			}

			return (
				<p className="value-line value-line--promotion">
					<strong className="text-uppercase">{ PROMOTION_TEXT_TITLE }</strong>
					<span className="fee-value">-{formatCurrency(discount)}</span>
				</p>
			);
		}

		return null;
	}

	render() {
		return (
			<div className="new-card your-buy-box">
				<header className="header-box">
					<h4 className="new-card__title">Sua compra</h4>
				</header>
				<div className="new-card__content">
					{this.renderAfterFeeFetching()}
					{!isTypePassageFiltered && this.renderRedirections()}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	try {
		return {
			selectedFlights: state.selectedFlights,
			searchParams: state.searchParams.params,
			createCheckoutData: {
				selectedFlights: state.selectedFlights,
				searchId: state.searchStatus.searchId,
				legacyId: state.searchStatus.legacyId,
				outboundId:
					state.selectedFlights.outbound.length > 0 ? state.selectedFlights.outbound[0].id : null,
				inboundId:
					state.selectedFlights.inbound.length > 0 ? state.selectedFlights.inbound[0].id : null
			},
			isInternational: state.searchStatus.isInternational
		};
	} catch (e) {
		console.log("deu ruim hein galerê");
	}
};

const mapDispatchToProps = dispatch => {
	return {
		createCheckout: createCheckoutData => dispatch(createNewCheckout(createCheckoutData)),
		openModal: () => dispatch(toggleModal(OPEN_MODAL)),
		flightDirectionRedirect: direction => dispatch(flightDirectionRedirect(direction))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(FlightBillingResume);
